import { IoLocation } from 'react-icons/io5'

import { DefaultProjectImage } from 'src/components/atoms/DefaultProjectImage'
import TypographyRebrand from 'src/components/atoms/TypographyRebrand/TypographyRebrand'

export interface ProjectHeroRebrandProps {
  name: string
  locationText?: string
  imageUrl?: string
}

export const ProjectHeroRebrand = ({
  name,
  locationText,
  imageUrl
}: ProjectHeroRebrandProps) => (
  <div className='hero-rebrand-dark unified relative w-full h-[500px] md:h-[826px] overflow-hidden'>
    {imageUrl ? (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        src={imageUrl}
        alt={name}
        className='absolute inset-0 w-full h-full object-cover'
      />
    ) : (
      <DefaultProjectImage
        className='absolute inset-0 w-full h-full'
        alt={name}
      />
    )}
    <div aria-hidden className='absolute inset-0 bg-black/60' />
    <div className='relative z-10 h-full container mx-auto px-4 lg:px-20 flex flex-col justify-end pb-12 md:pb-20'>
      {locationText && (
        <div className='flex items-center gap-2 mb-4 leading-none'>
          <IoLocation className='w-5 h-5 text-linen shrink-0' />
          <span className='font-body-rebrand text-base text-linen leading-none'>
            {locationText}
          </span>
        </div>
      )}
      <TypographyRebrand variant='h1' color='linen'>
        {name}
      </TypographyRebrand>
    </div>
  </div>
)
